export default __webpack_public_path__ + "GrabberClaw_small.dd4a6812.png";